module.exports = __webpack_public_path__ + "media/images/athletes/3139-1ddb06c0a0b11245747efea3453b64cb.png";